import React from "react";

const CustomLocationIcon: React.FC = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="17"
            fill="none"
            viewBox="0 0 14 17"
            role="presentation"
        >
            <path
                stroke="#545454"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M12.9 7.178c0 4.628-5.95 8.594-5.95 8.594S1 11.806 1 7.178a5.95 5.95 0 0111.9 0z"
            ></path>
            <path
                stroke="#545454"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M6.948 9.161a1.983 1.983 0 100-3.967 1.983 1.983 0 000 3.967z"
            ></path>
        </svg>
    );
};

export default React.memo(CustomLocationIcon);
